export const HOME_GROWN = '/home_grown/';
export const HOME_GROWN_PATCH = id => `/home_grown/${id}/`;
export const MY_HOME_GROWN = '/my_home_grown/';
export const PERSON_HOME_GROWN = person_id => `/person_home_grown/?person_id=${person_id}`;
export const EXPORT_HOME_GROWN_SHEETXLSX =  '/export_home_grown_sheetXLSX';
export const PERSON_PEND_PAID_HOME_GROWN =  '/person_pend_paid_home_grown/';
